import { TextInput as TextInputComponent } from '@randstad-lean-mobile-factory/react-components-core';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

import { ErrorMessage } from '../ErrorMessage';

import { TextInputProps } from './TextInput.types';

export const TextInput = <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  name,
  control,
  defaultValue,
  disabled,
  formFieldClassName,
  ...textInputProps
}: TextInputProps<TFieldValues, TName>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    disabled,
  });

  return (
    <div className={formFieldClassName}>
      <TextInputComponent
        {...textInputProps}
        {...field}
        onChange={event => {
          if (textInputProps.type === 'number') {
            const output = parseFloat(event.currentTarget.value);
            field.onChange(isNaN(output) ? undefined : output);
          } else {
            field.onChange(event.currentTarget.value);
          }
        }}
        onKeyDown={evt =>
          textInputProps.type === 'number' &&
          ['e', 'E', '+'].includes(evt.key) &&
          evt.preventDefault()
        }
        error={!!error}
        value={field.value ?? ''}
      />
      <ErrorMessage error={error} />
    </div>
  );
};
